module.exports = __webpack_public_path__ + "static/media/haProfil.8924f00b.png";